import { createAsyncThunk } from '@reduxjs/toolkit'
import MediaAnalytics from './media-analytics-model'
import {
  delete_mediaAnalytics,
  load_mediaAnalyticss,
  store_mediaAnalytics,
} from './mediaAnalytics-service'

export const LoadMediaAnalyticssAsync = createAsyncThunk<any, any>(
  'composer/load/mediaAnalytics',
  async (params: { uid: string }) => {
    return await load_mediaAnalyticss(params)
  },
)

export const CreateMediaAnalyticsAsync = createAsyncThunk<any, any>(
  'composer/create/mediaAnalytics',
  async (params: MediaAnalytics) => {
    return await store_mediaAnalytics(params)
  },
)

export const DeleteMediaAnalyticsAsync = createAsyncThunk<any, any>(
  'composer/delete/mediaAnalytics',
  async (params) => {
    return await delete_mediaAnalytics(params)
  },
)
